import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

import {TreeNodeTypeEnum} from '../tree-node-type.enum';

@Component({
    selector: 'adm4-deployment-resource-icon',
    template: `
@switch (type) {
  @case (TreeNodeTypeEnum.Host) {
    <mat-icon class='tree-node-icon'>storage</mat-icon>
  }
  @case (TreeNodeTypeEnum.Pattern) {
    <mat-icon class='tree-node-icon'>content_paste</mat-icon>
  }
  @case (TreeNodeTypeEnum.DeployablePattern) {
    <mat-icon class='tree-node-icon'>content_paste</mat-icon>
  }
  @case (TreeNodeTypeEnum.CheckParent) {
    <mat-icon class='tree-node-icon'>playlist_add_check</mat-icon>
  }
  @case (TreeNodeTypeEnum.CommandParent) {
    <mat-icon class='tree-node-icon'>input</mat-icon>
  }
  @case (TreeNodeTypeEnum.Directory) {
    <mat-icon class='tree-node-icon'>{{expanded ? 'folder_open' : 'folder'}}</mat-icon>
  }
  @case (TreeNodeTypeEnum.File) {
    <mat-icon class='tree-node-icon'>insert_drive_file</mat-icon>
  }
  @case (TreeNodeTypeEnum.KubernetesCustomResources) {
    <mat-icon class='tree-node-icon'>collections_bookmark</mat-icon>
  }
  @case (TreeNodeTypeEnum.KubernetesCustomResource) {
    <mat-icon class='tree-node-icon'>book</mat-icon>
  }
  @default {
    <mat-icon class='tree-node-icon'>insert_drive_file</mat-icon>
  }
}
`,
    styleUrls: ['./deployment-resource-icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DeploymentResourceIconComponent {

  public readonly TreeNodeTypeEnum = TreeNodeTypeEnum;

  @Input()
  public type: TreeNodeTypeEnum;

  @Input()
  public expanded: boolean;
}
